/* Vancity Theme JS */

// Document Ready
document.addEventListener('DOMContentLoaded', function () {

  // Mobile menu handlers
  if (window.jQuery) {
    const $ = window.jQuery;

    /* menu */
    $('.menuIcon').click(function(){
      $('.mo_menu').addClass('active');
      $('.main').addClass('active');
    });

    $('.sidemenu_close').click(function(){
      $('.mo_menu').removeClass('active');
      $('.main').removeClass('active');
    });

    /* Mobile Dropdown Js */
    $(".sideMenu .nav-list li .mobile_dropdown").click(function(){
      $(this).toggleClass("active");
      $(this).closest('li').siblings().find('.mobile_dropdown').removeClass('active').next('ul').slideUp(500);
      $(this).siblings('.navbar-dropdown').slideToggle('slow');
    });

    $('.nav-list li').mouseenter(function() {
      $(this).addClass('active');
    });
    $('.nav-list li').mouseleave(function() {
      $(this).removeClass('active');
    });

    /* Submenu */
    $(".submenu_main i").click(function(){  
      $(".submenu_inr").toggle("slow");
    });

    /* Marquee slider */
    if ($('.marquee_slider_inr').length && $.fn.slick) {
      $('.marquee_slider_inr').slick({
        infinite: true, 
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 10000,
        cssEase: 'linear',
        swipe: false, 
        arrows: false, 
        loop: true,
        variableWidth: false,
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 1250,
            settings: {
              autoplaySpeed: 1,
              speed: 12000,
              variableWidth: true
            }
          },
          {
            breakpoint: 991,
            settings: {
              autoplaySpeed: 1,
              speed: 14000,
              variableWidth: true
            }
          }
        ]
      });
    }
  }
});